import CrudRepository from './CrudRepository'
import Repository from './Repository'
export default class ReservationNumberRepositiory extends CrudRepository {
  constructor () {
    super('/core/api/numberReservations/search')
  }

  async postReservation (item, page, size) {
    const data = await Repository.post(`${this.resource}`, item, { params: { page: page, size: size } })
    return data
  }
}
